import { ApiClient } from "@topline/services/apiService";

export class ImsDataService {
    static componentName = "imsDataService";
    static $inject = [ApiClient.componentName];

    constructor(protected apiClient: ApiClient) {}

    getLatestDataDate(skuIds: number[], marketId: number) {
        return this.apiClient.getLastHistoricalDataDate({ marketId, skuIds });
    }

    getLatestData(forecastId?: number) {
        return this.apiClient
            .getImsData(forecastId)
            .then(r => ({ ...r, dataTo: new Date(r.dataTo), importDate: new Date(r.importDate) }));
    }
}

angular.module("topline.services").service(ImsDataService.componentName, ImsDataService);
